import { render, staticRenderFns } from "./buybutton.vue?vue&type=template&id=2726d550&scoped=true"
import script from "./buybutton.vue?vue&type=script&lang=js"
export * from "./buybutton.vue?vue&type=script&lang=js"
import style0 from "./buybutton.vue?vue&type=style&index=0&id=2726d550&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726d550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2726d550')) {
      api.createRecord('2726d550', component.options)
    } else {
      api.reload('2726d550', component.options)
    }
    module.hot.accept("./buybutton.vue?vue&type=template&id=2726d550&scoped=true", function () {
      api.rerender('2726d550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buybutton.vue"
export default component.exports